require('./pensionPlanLegalConfirmation.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const classNames = require('classnames');

// @core
const { FormattedText, formatText } = require('core/i18n').i18n;

// @components
const BrokerLegalConfirmation = require('components/contactCenter/brokerLegalConfirmation/brokerLegalConfirmation');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableGroupHeader } = require('commonsComponents/OKTableGroupHeader');
const { OKTableCell} = require('commonsComponents/OKTableCell');

// @actions
const brokerPlanLegalDocumentActions = require('actions/brokerPlanLegalDocument');
const pensionPlanLegalConfirmationActions = require('actions/contactCenter/pensionPlanLegalConfirmationActions');

// @utilities
const PersonalDataHelper = require('utilities/personalDataHelper');
const { buildLinkOrLabel } = require('utilities/contactCenter/UIElementsHelper');
const { formatAmount, formatPercentage } = require('utilities/currencyHelper');

// @constants
const { EURO_TEXT } = require('constants/index');
const UNIT_EUROS = 1;
const UNIT_SHARES = 11;

class PensionPlanLegalConfirmation extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            hasResolvedDependencies: false,
        }

        this.handleYesNoOptionChange = this.handleYesNoOptionChange.bind(this);
    }

    componentWillMount() {
        const { planDgsCode, planSecId, fetchLegalDocuments, fetchPensionPlanMorningstarInformation } = this.props;

        fetchLegalDocuments(planDgsCode, planSecId);
        fetchPensionPlanMorningstarInformation(planSecId);
    }

    componentWillReceiveProps(nextProps) {
        const {
            onResolvedDependencies,
            immBrokerPlanLegalDocument: oldImmBrokerPlanLegalDocument,
            immPensionPlanLegalConfirmation: oldImmPensionPlanLegalConfirmation,
        } = this.props;

        const {
            immBrokerPlanLegalDocument,
            immPensionPlanLegalConfirmation,
        } = nextProps;

        if ( immBrokerPlanLegalDocument !== oldImmBrokerPlanLegalDocument
            || immPensionPlanLegalConfirmation !== oldImmPensionPlanLegalConfirmation
        ) {

            const isFetchingLegalDocuments = immBrokerPlanLegalDocument.get('isFetching');
            const isFetchedLegalDocuments = immBrokerPlanLegalDocument.get('isFetched');
            const isFetchingMorningstarInformation = immPensionPlanLegalConfirmation.get('isFetching');
            const isFetchedMorningstarInformation = immPensionPlanLegalConfirmation.get('isFetched');
            const resolved = !isFetchingLegalDocuments && isFetchedLegalDocuments && !isFetchingMorningstarInformation && isFetchedMorningstarInformation;

            this.setState( (state) => {
                if (onResolvedDependencies && state.hasResolvedDependencies !== resolved) {
                    onResolvedDependencies(resolved)
                }

                return {
                    hasResolvedDependencies: resolved,
                };
            });
        }
    }

    componentWillUnmount() {
        this.props.resetPensionPlanMorningstarInformation();
    }

    handleYesNoOptionChange(value) {
        this.props.onYesNoOptionChange(value);
    }

    buildDocumentLink(labelTranslationKey, documentUrlKey) {
        const { immBrokerPlanLegalDocument } = this.props;

        const label = formatText(`pensionPlanLegalConfirmation-${labelTranslationKey}`);
        const link = immBrokerPlanLegalDocument.get(documentUrlKey);

        return buildLinkOrLabel(label, link);
    }

    buildLegalDisclaimerDocumentLinks() {
        const { immGlobalVariables, pensionPlanLegalFirstQuestion } = this.props;

        const fundamentalPlanDataLink = this.buildDocumentLink("fundamentalPlanDataLabelLink", "fundamentalPlanDataUrl");
        const subscriptionNewsletterLink = this.buildDocumentLink("subscriptionNewsletterLabelLink", "subscriptionNewsletterUrl");
        const specificationsDocumentLink = this.buildDocumentLink("specificationsDocumentLabelLink", "specificationsDocumentUrl");
        const contractNaturalPersonLink = buildLinkOrLabel(
            formatText("pensionPlanLegalConfirmation-pensionPlanLegalConfirmation_contractNaturalPersonLink"),
            immGlobalVariables.getIn(['variables', 'parameters', 'contratos','prestacion_servicios_fisicas']),
        );

        const legalInformationLinks = [
            fundamentalPlanDataLink,
            subscriptionNewsletterLink,
            specificationsDocumentLink,
            contractNaturalPersonLink,
        ];

        let disclaimerDocumentsLinksFirstStatement = "pensionPlanLegalConfirmation-legalDisclaimerDocumentsLinksFirstStatement";

        if(pensionPlanLegalFirstQuestion) {
            disclaimerDocumentsLinksFirstStatement = pensionPlanLegalFirstQuestion;
        }

        return (
            <div>
                <p>
                    <FormattedText value={disclaimerDocumentsLinksFirstStatement} />
                </p>
                <p>
                    <FormattedTextWithComponents
                        value="pensionPlanLegalConfirmation-pensionPlanLegalConfirmation_newLegalDisclaimerDocumentsLinksSecondStatement"
                        injectedComponents={legalInformationLinks}
                    />
                </p>
            </div>
        )

    }

    buildLegalDisclaimerQuestion() {
        const { immProfileFields, pensionPlanLegalDesclaimer } = this.props;
        const clientName = PersonalDataHelper.getFullName(immProfileFields, false);

        let legalDisclaimerFirstStatement = "pensionPlanLegalConfirmation-legalDisclaimerQuestionFirstStatement";

        if (pensionPlanLegalDesclaimer) {
            legalDisclaimerFirstStatement = pensionPlanLegalDesclaimer;
        }

        return (
            <div>
                <p>
                    <FormattedText value={legalDisclaimerFirstStatement} />
                </p>
                <p>
                    <FormattedText
                        value="pensionPlanLegalConfirmation-legalDisclaimerQuestionSecondStatement"
                        injectedStrings={[ clientName ]}
                    />
                </p>
            </div>
        );
    }

    buildLegalDisclaimerYesAnswer() {
        return (
            <div>
                <p><FormattedText value="pensionPlanLegalConfirmation-legalDisclaimerYesAnswerStatement" /></p>
            </div>
        );
    }

    buildLegalDisclaimerNoAnswer() {
        return (
            <div>
                <p><FormattedText value="pensionPlanLegalConfirmation-legalDisclaimerNoAnswerFirstStatement" /></p>
                <p><FormattedText value="pensionPlanLegalConfirmation-legalDisclaimerNoAnswerSecondStatement" /></p>
            </div>
        );
    }

    getUnitText(unit, amount) {
        let unitText;

        if (unit === UNIT_EUROS) {
            unitText = EURO_TEXT;
        } else if (unit === UNIT_SHARES) {
            unitText = (amount === 1) ? formatText('pensionPlanLegalConfirmation-share') : formatText('pensionPlanLegalConfirmation-shares');
        } else {
            unitText = '';
        }

        return unitText;
    }

    getAmountText(fieldNameAmount, fieldNameUnit) {
        const { immPensionPlanLegalConfirmation } = this.props;
        const immCommissionList = immPensionPlanLegalConfirmation.get('commissionList');
        const notAvailable = formatText('pensionPlanLegalConfirmation-notAvailable');

        const amount = immCommissionList.get(fieldNameAmount);
        const unit = immCommissionList.get(fieldNameUnit);

        return (amount ? `${formatAmount(amount)} ${this.getUnitText(unit, amount)}` : notAvailable);
    }

    getPercentageText(fieldName) {
        const { immPensionPlanLegalConfirmation } = this.props;
        const immCommissionList = immPensionPlanLegalConfirmation.get('commissionList');
        const notAvailable = formatText('pensionPlanLegalConfirmation-notAvailable');
        const checkField="managementFee";
        if (fieldName === checkField) {
            const managementFeeExDistFeeActual = immCommissionList.getIn(['mifid', 'managementFeeExDistFeeActual']);
            const managementFee = managementFeeExDistFeeActual ? formatPercentage(managementFeeExDistFeeActual ) : formatPercentage(immCommissionList.get(fieldName));
            return managementFee ? managementFee : notAvailable;
        }
        return immCommissionList.get(fieldName) ? formatPercentage(immCommissionList.get(fieldName)) : notAvailable;
    }

    getRatioText(fieldName) {
        const { immPensionPlanLegalConfirmation } = this.props;
        const immCommissionList = immPensionPlanLegalConfirmation.get('commissionList');
        const notAvailable = formatText('pensionPlanLegalConfirmation-notAvailable');

        return immCommissionList.get(fieldName) ? formatAmount(immCommissionList.get(fieldName)) : notAvailable;
    }

    buildLegalTextProductDescription() {
        const { immProfileFields, pensionPlanFullName, immPensionPlanLegalConfirmation } = this.props;

        const clientName = PersonalDataHelper.getFullName(immProfileFields, false);

        const notAvailable = formatText('pensionPlanLegalConfirmation-notAvailable');
        const investmentStrategy = immPensionPlanLegalConfirmation.get('fetchError') ? notAvailable : immPensionPlanLegalConfirmation.get('investmentStrategy');
        const riskLevel = immPensionPlanLegalConfirmation.get('fetchError') ? notAvailable : immPensionPlanLegalConfirmation.get('riskLevel');

        const investmentStrategyComponent  = (
            <p className="pension-plan-legal-confirmation__investment-strategy">
                {investmentStrategy}
            </p>
        );

        const riskLevelComponent = (
            <span className="pension-plan-legal-confirmation__risk-level">
                {riskLevel}
            </span>
        );

        const commissionListComponent  = (
            <div className="pension-plan-legal-confirmation__commission-list">
                <OKTable>
                    <tbody>
                        <OKTableRow>
                            <OKTableGroupHeader colSpan={2}>
                                <FormattedText value="pensionPlanLegalConfirmation-generalCommissions"/>
                            </OKTableGroupHeader>
                            <OKTableGroupHeader colSpan={2}>
                                <FormattedText value="pensionPlanLegalConfirmation-purchaseInformation"/>
                            </OKTableGroupHeader>
                        </OKTableRow>
                        <OKTableRow>
                            <OKTableCell>
                                <FormattedText value="pensionPlanLegalConfirmation-customBuyFee"/>
                            </OKTableCell>
                            <OKTableCell>
                                {this.getPercentageText('customBuyFee')}
                            </OKTableCell>
                            <OKTableCell>
                                <FormattedText value="pensionPlanLegalConfirmation-customMinimumPurchase"/>
                            </OKTableCell>
                            <OKTableCell>
                                {this.getAmountText('customMinimumPurchaseAmount', 'customMinimumPurchaseAmountUnit')}
                            </OKTableCell>
                        </OKTableRow>
                        <OKTableRow>
                            <OKTableCell>
                                <FormattedText value="pensionPlanLegalConfirmation-customSellFee"/>
                            </OKTableCell>
                            <OKTableCell>
                                {this.getPercentageText('customSellFee')}
                            </OKTableCell>
                            <OKTableCell>
                                <FormattedText value="pensionPlanLegalConfirmation-customMinimumAdditionalPurchase"/>
                            </OKTableCell>
                            <OKTableCell>
                                {this.getAmountText('customMinimumAdditionalPurchaseAmount', 'customMinimumAdditionalPurchaseAmountUnit')}
                            </OKTableCell>
                        </OKTableRow>
                        <OKTableRow>
                            <OKTableGroupHeader colSpan={4}>
                                <FormattedText value="pensionPlanLegalConfirmation-annualCommissions"/>
                            </OKTableGroupHeader>
                        </OKTableRow>
                        <OKTableRow>
                            <OKTableCell>
                                <FormattedText value="pensionPlanLegalConfirmation-managementFee"/>
                            </OKTableCell>
                            <OKTableCell>
                                {this.getPercentageText('managementFee')}
                            </OKTableCell>
                            <OKTableCell>
                                <FormattedText value="pensionPlanLegalConfirmation-custodianFee"/>
                            </OKTableCell>
                            <OKTableCell>
                                {this.getPercentageText('custodianFee')}
                            </OKTableCell>
                        </OKTableRow>
                        <OKTableRow>
                            <OKTableCell>
                                <FormattedText value="pensionPlanLegalConfirmation-performanceFee"/>
                            </OKTableCell>
                            <OKTableCell>
                                {this.getPercentageText('custodianFee')}
                            </OKTableCell>
                            <OKTableCell>
                                <FormattedText value="pensionPlanLegalConfirmation-totalExpenseRatio"/>
                            </OKTableCell>
                            <OKTableCell>
                                {this.getRatioText('totalExpenseRatio')}
                            </OKTableCell>
                        </OKTableRow>
                        <OKTableRow>
                            <OKTableCell>
                                <FormattedText value="pensionPlanLegalConfirmation-distributionFee"/>
                            </OKTableCell>
                            <OKTableCell>
                                {this.getPercentageText('distributionFee')}
                            </OKTableCell>
                            <OKTableCell>
                                <FormattedText value="pensionPlanLegalConfirmation-ongoingCharge"/>
                            </OKTableCell>
                            <OKTableCell>
                                {this.getRatioText('ongoingCharge')}
                            </OKTableCell>
                        </OKTableRow>
                    </tbody>
                </OKTable>
            </div>
        );

        return (
            <div>
                <p>
                    <FormattedText
                        value="pensionPlanLegalConfirmation-productMainFeaturesTitle"
                        injectedStrings={[ clientName ]}
                    />
                </p>
                <ul>
                    <li>
                        <FormattedText
                            value="pensionPlanLegalConfirmation-productFirstFeature"
                            injectedStrings={[ pensionPlanFullName ]}
                        />
                    </li>
                    <li>
                        <FormattedTextWithComponents
                            value="pensionPlanLegalConfirmation-productSecondFeature"
                            injectedComponents={[ investmentStrategyComponent ]}
                        />
                    </li>
                    <li>
                        <FormattedTextWithComponents
                            value="pensionPlanLegalConfirmation-productThirdFeature"
                            injectedComponents={[ riskLevelComponent ]}
                        />
                    </li>
                    <li>
                        <FormattedTextWithComponents
                            value="pensionPlanLegalConfirmation-productFourthFeature"
                            injectedComponents={[ commissionListComponent ]}
                        />
                    </li>
                </ul>
            </div>
        );
    }

    completeEmailParams() {
        const { immBrokerPlanLegalDocument, planDgsCode, sendMailParams } = this.props;

        const defaultEmailParams = {
            data: {
                producto: planDgsCode,
                encodedDocumentId1: immBrokerPlanLegalDocument.get('fundamentalPlanDataEncodedDocumentId'),
                encodedDocumentId2: immBrokerPlanLegalDocument.get('specificationsDocumentEncodedDocumentId'),
            }
        }

        const emailParams = Object.assign({},
            defaultEmailParams,
            sendMailParams,
            {
                data: Object.assign({},
                    defaultEmailParams.data,
                    sendMailParams ? sendMailParams.data : {}
                )
            }
        );

        return emailParams;
    }

    buildBrokerLegalConfirmation() {
        const {
            immProfileFields,
            immPreContractualMail,
            sendMail,
            resetMailState,
            requestProfile,
            selectedYesNoOption,
        } = this.props;

        const { hasResolvedDependencies } = this.state;

        if (!hasResolvedDependencies) {
            return (
                <LoadingSection/>
            );
        }

        const clientEmail = PersonalDataHelper.getEmail(immProfileFields);
        const refreshEmailError = immProfileFields.get('error');
        const emailParams = this.completeEmailParams();

        return (
            <BrokerLegalConfirmation
                className="pension-plan-legal-confirmation__legal-confirmation"
                legalDisclaimerProductDescription={this.buildLegalTextProductDescription()}
                legalDisclaimerDocumentLinks={this.buildLegalDisclaimerDocumentLinks()}
                clientEmailAddress={clientEmail}
                refreshEmailAddress={requestProfile}
                refreshEmailAddressError={refreshEmailError}
                sendMail={sendMail}
                sendMailParams={emailParams}
                immPreContractualMail={immPreContractualMail}
                resetMailState={resetMailState}
                legalDisclaimerQuestion={this.buildLegalDisclaimerQuestion()}
                selectedYesNoOption={selectedYesNoOption}
                onYesNoOptionChange={this.handleYesNoOptionChange}
                legalDisclaimerYesAnswer={this.buildLegalDisclaimerYesAnswer()}
                legalDisclaimerNoAnswer={this.buildLegalDisclaimerNoAnswer()}
            />
        );
    }

    render() {
        const { className } = this.props;
        const pensionPlanLegalConfirmationClassNames = classNames('pension-plan-legal-confirmation', { [className]: !!className });

        return (
            <div className={pensionPlanLegalConfirmationClassNames}>
                {this.buildBrokerLegalConfirmation()}
            </div>
        );
    }
}

PensionPlanLegalConfirmation.propTypes = {
    // Public props
    className: PropTypes.string,
    planDgsCode: PropTypes.string.isRequired,
    planSecId: PropTypes.string.isRequired,
    pensionPlanFullName: PropTypes.string.isRequired,
    requestProfile: PropTypes.func.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    sendMail: PropTypes.func.isRequired,
    sendMailParams: PropTypes.object.isRequired,
    resetMailState: PropTypes.func.isRequired,
    immPreContractualMail: PropTypes.object.isRequired,
    selectedYesNoOption: PropTypes.string.isRequired,
    onYesNoOptionChange: PropTypes.func.isRequired,
    onResolvedDependencies: PropTypes.func,
    pensionPlanLegalDesclaimer:  PropTypes.string,
    pensionPlanLegalFirstQuestion:  PropTypes.string,
    // Connected props
    fetchLegalDocuments: PropTypes.func.isRequired,
    immBrokerPlanLegalDocument: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    fetchPensionPlanMorningstarInformation: PropTypes.func.isRequired,
    resetPensionPlanMorningstarInformation: PropTypes.func.isRequired,
    immPensionPlanLegalConfirmation: PropTypes.object.isRequired,
};

module.exports.constructor = PensionPlanLegalConfirmation;
module.exports.PensionPlanLegalConfirmation = connect(state => ({
    immBrokerPlanLegalDocument: state.brokerPlanLegalDocument,
    immGlobalVariables: state.globalVariables,
    immPensionPlanLegalConfirmation: state.pensionPlanLegalConfirmation,
}), {
    fetchLegalDocuments: brokerPlanLegalDocumentActions.fetchLegalDocuments,
    fetchPensionPlanMorningstarInformation: pensionPlanLegalConfirmationActions.fetchPensionPlanMorningstarInformation,
    resetPensionPlanMorningstarInformation: pensionPlanLegalConfirmationActions.reset
})(PensionPlanLegalConfirmation);
